<template>
  <div id="dbpModalPortefeuille">
    <b-button v-b-modal="'my-modal' + this.uid">Décomposition</b-button>
    <b-modal modal-class="dbpModal" :title="'Les principales positions de votre titre ' + title" :id="'my-modal' + this.uid" centered hide-footer>
      <div>
        <b-table id="dbpModal-table" striped hover :fields="fields" :items="content" :per-page="perPage" :current-page="currentPage">
          <template #head(1)="data">
            <div class="tbHeader">
              <span class="tbHeader_label">{{ data.label }}</span>
            </div>
          </template>
          <template #head(2)="data">
            <div class="tbHeader">
              <span class="tbHeader_label">{{ data.label }}</span>
            </div>
          </template>
          <template #head(3)="data">
            <div class="tbHeader">
              <span class="tbHeader_label">{{ data.label }}</span>
            </div>
          </template>
          <template #cell(1)="data">
            <span class="tb_first_col">{{ data.item.name }} </span>
          </template>
          <template #cell(2)="data">
            <span class="tb_col_score">{{ data.item.isin }} </span>
          </template>
          <template #cell(3)="data">
            <span class="tb_col_score">{{ Number(data.item.weight).toFixed(2) }}% </span>
          </template>
        </b-table>
      </div>
    </b-modal>
  </div>
</template>
<script>
export default {
  props: ["title", "content"],
  data() {
    return {
      perPage: 99,
      currentPage: 1,
      form: [],
      fields: [
        { key: "1", label: "Position" },
        { key: "2", label: "ISIN" },
        { key: "3", label: "Poids (%)" },
      ],
      items: [],
    };
  },
  created() {
    let newArr = [];
    this.content.sort((a, b) => b.weight - a.weight);
    this.content.forEach((o) => {
      if (o.weight > 1) {
        newArr.push(o);
      }
    });
    this.items = newArr.sort((a, b) => a.name.localeCompare(b.name));
  },
};
</script>
<style lang="scss">
@import "../../../../../sass/_variables.scss";
#dbpModalPortefeuille {
  button {
    color: $purple_color;
    background: transparent;
    border: none;
    font-weight: bold;
    &:focus {
      border: none;
      background: transparent;
    }
    &:active {
      border: none;
      background: transparent;
    }
  }
}
.dbpModal {
  button {
    color: $purple_color;
    background: transparent;
    border: none;
    font-weight: bold;
    &:focus {
      border: none;
      background: transparent;
    }
    &:active {
      border: none;
      background: transparent;
    }
  }
  .modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1040;
    width: 100vw;
    height: 100vh;
  }

  .modal-content {
    background-color: #121212 !important;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 20px;
    opacity: 1;
    .modal-header {
      border-bottom: none !important;
      text-align: center;
      font: normal normal normal $mf_ft_size_big_title Dosis;
      letter-spacing: 0px;
      color: $mf_ft_color_white;
      opacity: 1;
    }
    .modal-body {
      text-align: justify;
    }
  }

  .modalContentCustom {
    text-align: justify;
  }

  #dbpModal-table {
    $thRadius: 20px;
    margin-top: 20px;
    margin-bottom: 0rem !important;

    .tbHeader {
      display: flex;
      justify-content: center;
      align-items: center;
      align-content: center;

      .tbHeader_label {
        margin-right: 15px;
      }
    }
    .tb_first_col {
      color: $purple_color;
    }

    .table thead th {
      vertical-align: bottom;
      border: none;
    }
    thead {
      background: transparent;
    }

    th {
      background-color: #242527;
      border: none;
      color: #f5f5f5;
      text-align: center;
      padding: 15px;
    }
    th:first-child {
      border-top-left-radius: $thRadius;
    }

    th:last-child {
      border-top-right-radius: $thRadius;
    }
    tr:last-child {
      td:first-child {
        border-bottom-left-radius: $thRadius;
      }
      td:last-child {
        border-bottom-right-radius: $thRadius;
      }
    }

    tr {
      text-align: center;
      font: normal normal bold $mf_ft_size_text Segoe UI;
      letter-spacing: 0px;
      border: 2px solid #121212;
      color: #cacaca;
      background-color: #242527;
      opacity: 1;
    }

    td {
      border: none;
      padding: 10px;
    }

    li > span {
      position: relative;
      display: block;
      padding: 0.5rem 0.75rem;
      margin-left: -1px;
      line-height: 1.25;
      color: black;
      background-color: transparent !important;
      border: none !important;
      cursor: pointer;
      font-size: 20px !important;
      font-weight: bold !important;
    }
  }
}
</style>
